import React from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import {Theme} from '@material-ui/core/styles/createMuiTheme';
import {makeStyles} from '@material-ui/styles';
import clsx from 'clsx';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 74,

    [theme.breakpoints.up('sm')]: {
      minWidth: 135,
    },
  },
  rightSpacer: {
    minWidth: '10vw'
  },
  text: {
    lineHeight: '1.2em',
    fontFamily: 'Nunito',
    fontWeight: 'bold'
  },
  block: {
    flex: '1',
  },
  blockButton: {
    width: '100%',
    height: '100%',
  },
  addTraveler: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.white,
    flexGrow: 3.2
  },
  addTravelerButton: {
    color: theme.palette.white,
    textTransform: 'none',
    fontSize: 16
  },
  roomFull: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    backgroundColor: 'rgba(178, 178, 178, 0.5)',
    color: theme.palette.black,
    paddingLeft: 13,
    paddingRight: 13
  },
  addRoom: {
    backgroundColor: '#f2f2f2',
    borderWidth: 2,
    borderColor: theme.palette.primary.main,
    borderStyle: 'solid',
    flexGrow: 1,
    marginTop: 10
  },
  addRoomButton: {
    color: theme.palette.primary.main,
    textTransform: 'none',
    background: '#f2f2f2',
    fontSize: 16
  },
}))

interface Props {
  isFull: boolean;
  maxOccupancy: number;
  isNextRoomAvailable: boolean;
  rightSpacerWidth: number | string;
  roomNumber: number;
  addGuestHandler: () => void;
  addRoomHandler: () => void;
}

const GuestListControl = (props: Props) => {
  const {
    isFull,
    maxOccupancy,
    isNextRoomAvailable,
    roomNumber,
    rightSpacerWidth,
    addRoomHandler,
    addGuestHandler
  } = props;
  const classes = useStyles();

  return (
    <React.Fragment>
      <Box className={classes.container}>
        {!isFull && (
          <Box className={clsx(classes.block, classes.addTraveler)}>
            <Button className={clsx(classes.text, classes.blockButton, classes.addTravelerButton)} onClick={addGuestHandler}>
              +<br/>Traveler
            </Button>
          </Box>
        )}

        {isFull && (
          <React.Fragment>
            <Box className={clsx(classes.block, classes.addTraveler, classes.roomFull)}>
              <Box className={classes.text}>Max occupancy: <br /> {maxOccupancy} reached</Box>
            </Box>

            {isNextRoomAvailable && (
              <Box className={clsx(classes.block, classes.addRoom)}>
                <Button
                  className={clsx(classes.text, classes.blockButton, classes.addRoomButton)}
                  onClick={addRoomHandler}
                  color="primary"
                >
                  +<br/>Add<br/>Room
                </Button>
              </Box>
            )}
          </React.Fragment>
        )}
      </Box>
      <Box style={{minWidth: rightSpacerWidth}} />
    </React.Fragment>
  )
}

export default GuestListControl
